export const Codes = {
  SyncShippedAuthenticated: 'SYNC-AUTHENTICATED',
  SyncShippedStarted: 'SYNC-STARTED',
  SyncShippedFinished: 'SYNC-COMPLETED',
  ImportAuthenticated: 'IMPORT-AUTHENTICATED',
  ImportStarted: 'IMPORT-STARTED',
  ImportFinished: 'IMPORT-COMPLETED',
  RuleApplierStarted: 'RULE-STARTED',
  RuleApplierFinished: 'RULE-COMPLETED',
  PersistenceStarted: 'SAVE-STARTED',
  PersistenceFinished: 'SAVE-COMPLETED',
  CustomError: 'ERROR',
  CredentialsExpired: 'CREDS-EXPIRED',
  WiderIssue: 'WIDER-ISSUE',
  ImportThrottled: 'IMPORT-THROTTLED',
  AuthorisationFailed: 'AUTH-FAILED',
  SetupRequired: 'SETUP-REQUIRED',
  ScopeMissing: 'SCOPE-MISSING',
  AutoDispatchFail: 'AUTO-DISPATCH-FAIL',
  FbmShipPlus: 'USER-ACTION-FBM-SHIP-PLUS'
};

export class SocketItemUpdateValueModel {
  [key: string]: any;
}

export interface SocketItemUpdateModel {
  Id: string;
  ItemUpdates: SocketItemUpdateValueModel;
}

export interface SocketUpdateModel {
  Items: SocketItemUpdateModel[];
}

export type MarketplaceWorkerNotificationType = 'import' | 'syncshipped' | 'update';

export interface MarketplaceWorkerNotification {
  Affected: number;
  Stage: MarketplaceWorkerNotificationType;
  Code: string;
  Status?: string;
  Info: string;
  CustomerId?: string;
  MPAccountId: string;
  MarketplaceSource: string;
  SentTime: Date;
  UserId: string;
}

export interface SocketMarketplaceWorkerNotificationModel {
  Details: MarketplaceWorkerNotification;
}

export interface ImportStatusGroup {
  Updates: MarketplaceWorkerNotification[];
  MPAccountId: string;
  MPAccountName: string;
  MarketplaceSource: string;
  UserId: string;
  SentTime: Date;
  Stage: MarketplaceWorkerNotificationType;
  SubTitle: string;
  IsError: boolean;
  Links: { [key: string]: string };
}

export interface ImportStatusSummary {
  Import?: ImportStatusGroup;
  Sync?: ImportStatusGroup;
  Update?: ImportStatusGroup;
  MPAccountId: string;
  IsError: boolean;
  MarketplaceSource: string;
  UserId: string;
}
